import { render, staticRenderFns } from "./vue-numeric.vue?vue&type=template&id=037a3b79"
import script from "./vue-numeric.vue?vue&type=script&lang=js"
export * from "./vue-numeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports